export default "__VITE_ASSET__C$1xPBQt__"